export type WbUploaderFileFormat = {
  mime: string;
  label: string;
  extensions: string[];
  previewable: boolean;
};

export const WB_UPLOADER_FORMAT_PNG: WbUploaderFileFormat = {
  mime: 'image/png',
  label: 'PNG',
  extensions: ['.png'],
  previewable: true,
};

export const WB_UPLOADER_FORMAT_JPG: WbUploaderFileFormat = {
  mime: 'image/jpeg',
  label: 'JPG',
  extensions: ['.jpg', '.jpeg'],
  previewable: true,
};

export const WB_UPLOADER_FORMAT_SVG: WbUploaderFileFormat = {
  mime: 'image/svg+xml',
  label: 'SVG',
  extensions: ['.svg'],
  previewable: true,
};

export const WB_UPLOADER_FORMAT_PDF: WbUploaderFileFormat = {
  mime: 'application/pdf',
  label: 'PDF',
  extensions: ['.pdf'],
  previewable: true,
};

export const WB_UPLOADER_FORMAT_PPTX: WbUploaderFileFormat = {
  mime: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  label: 'PPTX',
  extensions: ['.pptx'],
  previewable: false,
};

export const WB_UPLOADER_FORMAT_DOCX: WbUploaderFileFormat = {
  mime: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  label: 'DOCX',
  extensions: ['.docx'],
  previewable: false,
};
